module.exports = __webpack_public_path__ + "static/media/nationsafedrivers.f09357b5.jpg";